
import {mapState, mapActions, mapMutations, mapGetters} from 'vuex';

export default {
	name: 'ChatMessage',
	data () {
		return {

		}
	},
	computed: {
		...mapState({
			selectedRoom: state => state.chatapp.selectedRoom,
			tempRoom: state => state.chatapp.tempRoom,
		}),
	},
	mounted() {

	},
	methods: {

	},
}
